// extracted by mini-css-extract-plugin
export default {"hands":"styles_hands__Lhl7w","handsList":"styles_handsList__MHKaV","handsItem":"styles_handsItem__Er7rH","textList":"styles_textList__+t3rJ","text":"styles_text__FWNWs"};